import { ButtonProps } from 'antd';
import { FC } from 'react';
import BaseButton from './BaseButton';

const SecondaryButton: FC<ButtonProps> = (props) => <BaseButton size="large" {...props} />;

export default SecondaryButton;
